import { useCallback, useEffect, useState } from 'react';

import { supabase } from '../lib/supabase';
import { useAuth } from '../auth/AuthProvider';

export interface MyRestaurant {
  id: string;
  name: string;
  slug: string;
  locale: string;
  currency: string;
  role: string;
  can_finance: boolean;
  expires_at: string | null;
}

export function useMyRestaurants() {
  const { user } = useAuth();
  const [restaurants, setRestaurants] = useState<MyRestaurant[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) {
      setRestaurants([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from('restaurant_members')
      .select('role, can_finance, expires_at, restaurants(id, name, slug, locale, currency)')
      .eq('user_id', user.id);

    if (!error && data) {
      const list = data
        .filter((row) => row.restaurants)
        .map((row) => {
          const r = row.restaurants as unknown as Omit<MyRestaurant, 'role' | 'can_finance' | 'expires_at'>;
          return { ...r, role: row.role as string, can_finance: Boolean(row.can_finance), expires_at: (row.expires_at as string | null) ?? null };
        });
      setRestaurants(list);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    void load();
  }, [load]);

  return { restaurants, loading, reload: load };
}
